import { Controller } from '@hotwired/stimulus';

// The page of /hq/signal listens on one Turbo stream for a job's landing and
// morphs when it hears (docs/SIGNAL.md § What the page reads). A button
// redirects to a NEW page, and a job that finishes before that page's stream
// has joined broadcast to nobody. A page drawn right after a button (pending)
// therefore looks once more the moment its stream says it is connected, and
// asks for itself again only if something has landed meanwhile: a refresh that
// changed nothing would only wipe the "Queued" notice the person is reading.
// Everything after that arrives by the broadcast. A button that redirects to
// this very page morphs it, and the morph would strip `connected` from a stream
// that is still up (the new HTML never carries it): keep() refuses that.
export default class extends Controller {
  static values = { pending: Boolean };

  connect() {
    this.stream = this.element.querySelector('turbo-cable-stream-source');
    if (!this.stream) return;

    this.watch = new MutationObserver(() => this.joined());
    this.watch.observe(this.stream, { attributes: true, attributeFilter: ['connected'] });
    this.joined();
  }

  disconnect() {
    this.watch?.disconnect();
  }

  keep(event) {
    if (event.detail.attributeName === 'connected') event.preventDefault();
  }

  async joined() {
    if (!this.pendingValue || !this.stream.hasAttribute('connected')) return;

    this.pendingValue = false;
    try {
      const reply = await fetch(window.location.href, { headers: { Accept: 'text/html' }, credentials: 'same-origin' });
      const fresh = new DOMParser().parseFromString(await reply.text(), 'text/html');
      if (this.words(fresh) !== this.words(document)) window.Turbo.visit(window.location.href, { action: 'replace' });
    } catch {
      // The page only reads: not being able to look again leaves it as it was.
    }
  }

  // What the panels say, as words: the forms' tokens and the stream's own
  // attributes differ on every draw and mean nothing.
  words(root) {
    return [...root.querySelectorAll('section.panel')].map((box) => box.textContent.replace(/\s+/g, ' ').trim()).join('|');
  }
}
